import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'lp-components'
import { IMAGE_PATH } from 'config'

const propTypes = {
  boats_info: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  confirmationHandler: PropTypes.func.isRequired,
  description: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

const NextStepsContent = ({
  boats_info,
  buttonText,
  confirmationHandler,
  description,
  title,
}) => {
  return (
    <>
      <img alt="" src={IMAGE_PATH.ANCHOR_ICON} className="confirmation-icon" />
      <h2>{title}</h2>
      <p>{description}</p>

      <div className="text-block">
        <div className="text-block-item">
          <strong>To ensure we can best service you:</strong>
          <ul className="bullets">
            <li>{boats_info}</li>
            <li>
              Add additional contacts and manage your communications preferences
            </li>
          </ul>
        </div>
        <div className="text-block-item">
          <strong>Use your online account to:</strong>
          <ul className="bullets">
            <li>Manage your Automatic Renewal Enrollment</li>
            <li>Update your membership details</li>
            <li>Browse member-only video and blog content</li>
            <li>
              Access deals and discounts through Sea Tow Savings Club&trade;
            </li>
            <li>View your Refer-A-Boater credits</li>
          </ul>
        </div>
      </div>
      <Button onClick={confirmationHandler}>{buttonText}</Button>
    </>
  )
}

NextStepsContent.propTypes = propTypes

export default NextStepsContent
